<section class="content">
  <div class="container-fluid">
    <h1>
      Assign Role to User
      <small></small>
    </h1>
    <div class="box">
      <div class="box-header row justify-content-between">
        <div class="col-auto">
          <h3 class="box-title">All Assigned Roles to User</h3>
        </div>
        <div class="col-auto right pad-btm-res">
          <button type="button" class="btn btn-light" (click)="exportData()" *ngIf="this.userType=='superadmin'"> <i
              aria-hidden="true" class="fa fa-download"></i> Export Csv</button> &nbsp;
          <button type="button" class="btn btn-light" (click)="importData()" *ngIf="this.userType=='superadmin'"> <i
              aria-hidden="true" class="fa fa-upload"></i> Import Csv</button> &nbsp;
          <button type="button" class="btn btn-secondary " (click)="orgModal('')"> <i class="fa fa-plus"
              aria-hidden="true"></i> &nbsp;&nbsp; Assign Role to User</button>
        </div>
        <div class="col-sm-12">
          <div class="row">
            <div class="col-lg-3 col-md-6 right col-sm-12">
              <div class="input-group mb-3">
                <input class="form-control search-btn" type="text" placeholder="Search" aria-label="Search"
                  aria-describedby="search-btn" [(ngModel)]="searchInput" (ngModelChange)="searchChanged()">
                <div class="input-group-append">
                  <span class="input-group-text" id="search-btn">
                    <i class="fa fa-search text-grey" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
      <!-- /.box-header -->
      <div class="box-body table-responsive">
        <table id="example1" class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Sl.No</th>
              <th>Day</th>
              <th>Participant</th>
              <th>Event Name</th>
              <th>User Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let item of userList  | filter:searchInput | paginate: { itemsPerPage: limit, currentPage: page, totalItems: count } let i = index">
              <td>{{ limit*(page-1)+(i+1) }}.</td>
              <td>{{ item.day}}</td>
              <td>{{ item.user_role==1?"Speaker":item.user_role==2?"Delegate":item.user_role==3?"AFGG":"-NA-"}}</td>
              <td>{{ item.org_name?item.org_name:"-NA-"}}</td>
              <td>{{ item.user_name?item.user_name:"-NA-"}}</td>
              <td>
                <button type="button" class="btn btn-sm btn-default mr-2 command-edit btn-margin "
                  (click)="saveDataPush(item.id)">
                  <em class="fa fa-eye fa-fw"></em>
                </button>
                <button type="button" class="btn btn-sm btn-default mr-2 command-edit" (click)="orgModal(item.id)">
                  <em class="fa fa-edit fa-fw"></em>
                </button>
                <button [disabled]="false" type="button" class="btn btn-sm btn-danger mr-2 command-edit"
                  (click)="confirmModal(content,item.id)">
                  <em class="fa fa-trash fa-fw"></em>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="paginate">
          <pagination-controls class="my-pagination" (pageChange)="paginate(page = $event)"></pagination-controls>
        </div>
      </div>
      <!-- /.box-body -->
    </div>
    <!-- /.box -->
  </div>
</section>
<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Are You sure to delete? </h4>
    <button type="button" class="close btn" aria-label="Close" (click)="closeconfirm('no')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger btn-sm" (click)="closeconfirm('no')">Cancel</button>
    <button type="button" class="btn btn-primary btn-sm" (click)="closeconfirm('yes')">Confirm</button>
  </div>
</ng-template>